// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"b4020d98","297":"87dd846e","484":"8db419eb","643":"6851ff71","787":"a5777865"}[chunkId] + ".chunk.js";
};